import React, { useState } from 'react';
import FramePlayer from '../utils/FramePlayer';
import Piano from '../utils/Piano';
import lang from '../lang.json';

const Module4c3 = (props) => {

    const langue = props.langue;
    const texts = lang.lang[`lang_${langue}`].module4c3;

    const [display11, setDisplay11] = useState("none");
    const [display12, setDisplay12] = useState("none");
    const [display13, setDisplay13] = useState("none");
    const [display21, setDisplay21] = useState("none");
    const [display22, setDisplay22] = useState("none");
    const [display23, setDisplay23] = useState("none");
    const [display31, setDisplay31] = useState("none");
    const [display32, setDisplay32] = useState("none");
    const [display33, setDisplay33] = useState("none");
    const [display41, setDisplay41] = useState("none");
    const [display42, setDisplay42] = useState("none");
    const [display43, setDisplay43] = useState("none");
    const [display51, setDisplay51] = useState("none");
    const [display52, setDisplay52] = useState("none");
    const [display53, setDisplay53] = useState("none");

    const [pause, setPause] = useState(true);

    const [hasStarted, setHasStarted] = useState(false);

    const print = (time, paused) => {
        console.log(time, paused);
    }

    const animCallback = (time, paused) => {
        setPause(paused);
        if (!hasStarted && time > 0) {
            setHasStarted(true);
        }
        /* page 1 */
        if (time >= 0 && time < 45.5) {
            setDisplay11("block");
        } else {
            setDisplay11("none");
        }
        if (time >= 10.8 && time < 45.5) {
            setDisplay12("block");
        } else {
            setDisplay12("none");
        }
        if (time >= 32.7 && time < 45.5) {
            setDisplay13("block");
        } else {
            setDisplay13("none");
        }
        /* page 2 */
        if (time >= 45.5 && time < 90.8) {
            setDisplay21("block");
        } else {
            setDisplay21("none");
        }
        if (time >= 61.94 && time < 90.8) {
            setDisplay22("block");
        } else {
            setDisplay22("none");
        }
        if (time >= 79.2 && time < 90.8) {
            setDisplay23("block");
        } else {
            setDisplay23("none");
        }
        /* page 3 */
        if (time >= 90.8 && time < 129.5) {
            setDisplay31("block");
        } else {
            setDisplay31("none");
        }
        if (time >= 101.9 && time < 129.5) {
            setDisplay32("block");
        } else {
            setDisplay32("none");
        }
        if (time >= 117.4 && time < 129.5) {
            setDisplay33("block");
        } else {
            setDisplay33("none");
        }
        /* page 4 */
        if (time >= 129.5 && time < 186) {
            setDisplay41("block");
        } else {
            setDisplay41("none");
        }
        if (time >= 140.7 && time < 186) {
            setDisplay42("block");
        } else {
            setDisplay42("none");
        }
        if (time >= 154 && time < 186) {
            setDisplay43("block");
        } else {
            setDisplay43("none");
        }
        /* page 5 */
        if (time >= 186 && time < 219.5) {
            setDisplay51("block");
        } else {
            setDisplay51("none");
        }
        if (time >= 190 && time < 219.5) {
            setDisplay52("block");
        } else {
            setDisplay52("none");
        }
        if (time >= 213.9 && time < 219.5) {
            setDisplay53("block");
        } else {
            setDisplay53("none");
        }
    }

    return (
        <>
            <Piano
                dirName={"piano4c3"}
                numberOfPages={5}
                pageSpeeds={[45.5, 45.3, 38.7, 56.5, 33.5]} // duree des pages en s
                height={220}
                musicName={"piano4c3"}
                callback={animCallback}
                style={{ position: 'absolute', top: '230px' }}
            />
            {/*Page 1*/}
            <img src={process.env.PUBLIC_URL + "/assets/images/module4c3/11.jpg"}
                alt="page1 image"
                style={{ position: 'absolute', top: '0px', left: '0px', display: display11 }} />
            <svg style={{ position: 'absolute', top: '0px', left: '0px', width: '660px', height: '500px', zIndex: 5, pointerEvents: 'none', display: display11 }}>
                {/*dashed line*/}
                <line x1="165" y1="0" x2="165" y2="230" stroke="white" strokeWidth={4} strokeDasharray={"9 2"} />
            </svg>
            <img src={process.env.PUBLIC_URL + "/assets/images/module4c3/12.jpg"}
                alt="page1 image"
                style={{ position: 'absolute', top: '0px', left: '168px', display: display12 }} />
            <svg style={{ position: 'absolute', top: '0px', left: '0px', width: '660px', height: '500px', zIndex: 5, pointerEvents: 'none', display: display12 }}>
                {/*dashed line*/}
                <line x1="476" y1="0" x2="476" y2="230" stroke="white" strokeWidth={4} strokeDasharray={"9 2"} />
            </svg>
            <img src={process.env.PUBLIC_URL + "/assets/images/module4c3/13.jpg"}
                alt="page1 image"
                style={{ position: 'absolute', top: '0px', left: '477px', display: display13 }} />

            {/*Page 2*/}
            <img src={process.env.PUBLIC_URL + "/assets/images/module4c3/21.jpg"}
                alt="page2 image"
                style={{ position: 'absolute', top: '0px', left: '0px', display: display21 }} />
            <svg style={{ position: 'absolute', top: '0px', left: '0px', width: '660px', height: '500px', zIndex: 5, pointerEvents: 'none', display: display21 }}>
                {/*dashed line*/}
                <line x1="247" y1="0" x2="247" y2="230" stroke="white" strokeWidth={4} strokeDasharray={"9 2"} />
            </svg>
            <img src={process.env.PUBLIC_URL + "/assets/images/module4c3/22.jpg"}
                alt="page2 image"
                style={{ position: 'absolute', top: '0px', left: '249px', display: display22 }} />
            <svg style={{ position: 'absolute', top: '0px', left: '0px', width: '660px', height: '500px', zIndex: 5, pointerEvents: 'none', display: display21 }}>
                {/*dashed line*/}
                <line x1="493" y1="0" x2="493" y2="230" stroke="white" strokeWidth={4} strokeDasharray={"9 2"} />
            </svg>
            <img src={process.env.PUBLIC_URL + "/assets/images/module4c3/23.jpg"}
                alt="page2 image"
                style={{ position: 'absolute', top: '0px', left: '495px', display: display23 }} />

            {/*Page 3*/}
            <img src={process.env.PUBLIC_URL + "/assets/images/module4c3/31.jpg"}
                alt="page3 image"
                style={{ position: 'absolute', top: '0px', left: '0px', display: display31 }} />
            <svg style={{ position: 'absolute', top: '0px', left: '0px', width: '660px', height: '500px', zIndex: 5, pointerEvents: 'none', display: display31 }}>
                {/*dashed line*/}
                <line x1="197" y1="0" x2="197" y2="230" stroke="white" strokeWidth={4} strokeDasharray={"9 2"} />
            </svg>
            <img src={process.env.PUBLIC_URL + "/assets/images/module4c3/32.jpg"}
                alt="page3 image"
                style={{ position: 'absolute', top: '0px', left: '199px', display: display32 }} />
            <svg style={{ position: 'absolute', top: '0px', left: '0px', width: '660px', height: '500px', zIndex: 5, pointerEvents: 'none', display: display31 }}>
                {/*dashed line*/}
                <line x1="456" y1="0" x2="456" y2="230" stroke="white" strokeWidth={4} strokeDasharray={"9 2"} />
            </svg>
            <img src={process.env.PUBLIC_URL + "/assets/images/module4c3/33.jpg"}
                alt="page3 image"
                style={{ position: 'absolute', top: '0px', left: '458px', display: display33 }} />

            {/*Page 4*/}
            <img src={process.env.PUBLIC_URL + "/assets/images/module4c3/41.jpg"}
                alt="page4 image"
                style={{ position: 'absolute', top: '0px', left: '0px', display: display41 }} />
            <svg style={{ position: 'absolute', top: '0px', left: '0px', width: '660px', height: '500px', zIndex: 5, pointerEvents: 'none', display: display41 }}>
                {/*dashed line*/}
                <line x1="139" y1="0" x2="139" y2="230" stroke="white" strokeWidth={4} strokeDasharray={"9 2"} />
            </svg>
            <img src={process.env.PUBLIC_URL + "/assets/images/module4c3/42.jpg"}
                alt="page4 image"
                style={{ position: 'absolute', top: '0px', left: '141px', display: display42 }} />
            <svg style={{ position: 'absolute', top: '0px', left: '0px', width: '660px', height: '500px', zIndex: 5, pointerEvents: 'none', display: display41 }}>
                {/*dashed line*/}
                <line x1="294" y1="0" x2="294" y2="230" stroke="white" strokeWidth={4} strokeDasharray={"9 2"} />
            </svg>
            <img src={process.env.PUBLIC_URL + "/assets/images/module4c3/43.jpg"}
                alt="page4 image"
                style={{ position: 'absolute', top: '0px', left: '296px', display: display43 }} />

            {/*Page 5*/}
            <img src={process.env.PUBLIC_URL + "/assets/images/module4c3/51.jpg"}
                alt="page5 image"
                style={{ position: 'absolute', top: '0px', left: '0px', display: display51 }} />
            <svg style={{ position: 'absolute', top: '0px', left: '0px', width: '660px', height: '500px', zIndex: 5, pointerEvents: 'none', display: display51 }}>
                {/*dashed line*/}
                <line x1="90" y1="0" x2="90" y2="230" stroke="white" strokeWidth={4} strokeDasharray={"9 2"} />
            </svg>
            <img src={process.env.PUBLIC_URL + "/assets/images/module4c3/52.jpg"}
                alt="page5 image"
                style={{ position: 'absolute', top: '0px', left: '92px', display: display52 }} />
            <svg style={{ position: 'absolute', top: '0px', left: '0px', width: '660px', height: '500px', zIndex: 5, pointerEvents: 'none', display: display52 }}>
                {/*dashed line*/}
                <line x1="550" y1="0" x2="550" y2="230" stroke="white" strokeWidth={4} strokeDasharray={"9 2"} />
            </svg>
            <img src={process.env.PUBLIC_URL + "/assets/images/module4c3/53.jpg"}
                alt="page5 image"
                style={{ position: 'absolute', top: '0px', left: '551px', display: display53 }} />

            {/* textes */}
            <p
                style={{
                    position: 'absolute',
                    left: 0,
                    top: 0,
                    color: 'white',
                    fontSize: '15px',
                    zIndex: 15
                }}
            >{texts.lang1}</p>
            <p
                className='t1'
                style={{
                    position: 'absolute',
                    left: 200,
                    top: 20,
                    color: 'white',
                    fontSize: '15px',
                    zIndex: 15,
                    display: hasStarted ? 'none' : 'block'
                }}
            >{texts.lang30}</p>
        </>
    );
}

export default Module4c3;
